import TrCurrency from './currencyDir.js';

angular.module('channel.directives.formatting', []).directive('trCurrency', TrCurrency);
